import React from "react";

class LoadingPage extends React.Component {
    render() {
        return (<div>Loading ...</div>);
    }
}

export default LoadingPage;